import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { api, errMsg } from "@/lib/api";
import { useRedEstado } from "@/lib/red";

export const IntroRequestSheet = ({ open, onOpenChange, r, servicio, ciudad, necesidad }) => {
  const nav = useNavigate();
  const [estado] = useRedEstado();
  const [text, setText] = useState("");
  const [wa, setWa] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) setText(necesidad || `Busco ${r.servicio}${ciudad ? ` en ${ciudad}` : ""}`); }, [open, necesidad, r, ciudad]);
  useEffect(() => { if (open && estado?.telefono_privado) setWa((w) => w || estado.telefono_privado); }, [open, estado]);
  const send = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/red/solicitudes", { dueno_id: r.dueno.id, servicio, ciudad: ciudad || null, necesidad: text.trim(), whatsapp: wa.trim() || null });
      toast.success(`Solicitud enviada a ${r.dueno.nombre_publico}`);
      onOpenChange(false);
      nav(`/conecta/solicitudes/${data.id}`);
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="bottom" data-testid="intro-request-sheet" className="max-h-[92vh] overflow-y-auto rounded-t-2xl space-y-3 pb-[max(1.5rem,env(safe-area-inset-bottom))]">
        <SheetHeader className="text-left">
          <SheetTitle>Pedir presentación a {r.dueno.nombre_publico}</SheetTitle>
          <SheetDescription>{r.dueno.nombre_publico} verá quién eres y qué necesitas. Si acepta, te comparte el contacto.</SheetDescription>
        </SheetHeader>
        <label className="block space-y-1"><span className="text-xs c-text-2">¿Qué necesitas? (una línea)</span>
          <input data-testid="intro-need-input" maxLength={200} className="c-input" value={text} onChange={(e) => setText(e.target.value)} />
        </label>
        <label className="block space-y-1"><span className="text-xs c-text-2">Tu WhatsApp para la presentación</span>
          <input data-testid="intro-whatsapp-input" type="tel" inputMode="tel" className="c-input" placeholder="55 1234 5678" value={wa} onChange={(e) => setWa(e.target.value)} />
          <span className="block text-[11px] c-muted">Solo lo ve {r.dueno.nombre_publico} para presentarte por WhatsApp.</span>
        </label>
        <button data-testid="intro-send-btn" disabled={busy || text.trim().length < 2} onClick={send} className="c-btn-primary w-full py-3 flex items-center justify-center gap-2">
          {busy && <Loader2 className="w-4 h-4 animate-spin" />} Enviar solicitud
        </button>
      </SheetContent>
    </Sheet>
  );
};
